export type EndpointConfig = {
    url: string;
    method: 'patch' | 'get' | 'post' | 'delete';
    auth?: boolean;
    sensitive?: boolean; // Skips logging request body
  };
  
  export enum Endpoints {
    healthz = 'healthz',
  
    signin = 'signin',
    signup = 'signup',
    reqResetpass = 'reqResetpass',
    resetpass = 'resetpass',
    
    getUserById = 'getUserById',
    getUserByEmail = 'getUserByEmail',
    getUserByPhone = 'getUserByPhone',
    getCurrentUser = 'getCurrentUser',
    updateUser = 'updateUser',
    updateCurrentUser = 'updateCurrentUser',
    addCaptin = 'addCaptin',
    listCaptins = 'listCaptins',
    listShipps = 'listShipps',
    listShippsOfCrUserByState= 'listShippsOfCrUserByState',
    getShipp = 'getShipp',
    createShipp = 'createShipp',
    editShipp = 'editShipp',
    updateShipp = 'updateShipp',

  }
  


  export function withParams(endpoint: EndpointConfig, ...params: string[]): EndpointConfig {
    let url = endpoint.url;
    const placeholders = url.match(/:[^\/]*/g) || [];
    if (placeholders.length !== params.length) {
      throw `Too ${placeholders.length < params.length ? 'many' : 'few'} params for url: ${url}!`;
    }
    for (let index = 0; index < params.length; index++) {
      url = url.replace(placeholders[index], params[index]);
    }
    return {
      url: url,
      method: endpoint.method,
      auth: endpoint.auth,
    } as EndpointConfig;
  }
  
   export const ENDPOINT_CONFIGS: { [key in Endpoints]: EndpointConfig } = {
    [Endpoints.healthz]: { method: 'get', url: '/api/v1/healthz' },
  
    [Endpoints.signin]: { method: 'post', url: '/api/v1/signin', sensitive: true },
    [Endpoints.signup]: { method: 'post', url: '/api/v1/signup', sensitive: true },
    [Endpoints.reqResetpass]: { method: 'post', url: '/api/v1/reqresetpass', sensitive: true },
    [Endpoints.resetpass]: { method: 'post', url: '/api/v1/resetpass', sensitive: true },

    [Endpoints.getUserById]: { method: 'get', url: '/api/v1/users/:id',auth:true },
    [Endpoints.getUserByEmail]: { method: 'get', url: '/api/v1/usersemail/:email' ,auth:true},
    [Endpoints.getUserByPhone]: { method: 'get', url: '/api/v1/usersphone/:phone', auth:true },
    [Endpoints.getCurrentUser]: { method: 'get', url: '/api/v1/users', auth: true },
    [Endpoints.updateUser]: { method: 'post', url: '/api/v1/updateuser', auth: true },
    [Endpoints.updateCurrentUser]: { method: 'patch', url: '/api/v1/users', auth: true },
    [Endpoints.addCaptin]: { method: 'post', url: '/api/v1/addcaptin', auth: true },
    [Endpoints.listCaptins]: { method: 'get', url: '/api/v1/captins', auth: true },
  
    [Endpoints.listShipps]: { method: 'get', url: '/api/v1/shipps/:filter', auth: true },
    [Endpoints.listShippsOfCrUserByState]: { method: 'get', url: '/api/v1/cushipps/:state', auth: true },
    [Endpoints.getShipp]: { method: 'get', url: '/api/v1/shipp/:id', auth: true} ,
    [Endpoints.createShipp]: { method: 'post', url: '/api/v1/newshipp', auth: true },

    [Endpoints.editShipp]: { method: 'post', url: '/api/v1/editshipp/:shippId', auth: true },
    [Endpoints.updateShipp]: { method: 'post', url: '/api/v1/updateshipp/:shippId', auth: true },
 
  };

